import axios from 'axios';
// import https from 'https';

// const agent = new https.Agent({ rejectUnauthorized: false }); // 忽略证书验证
// export const axiosAgent = axios.create({ httpsAgent: agent });

// 创建 axios 实例
const apiClient = axios.create({
  // baseURL: 'http://192.168.8.137:8082/express', 
  baseURL: 'https://www.lbt56.cn/api/express',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器（可选）
apiClient.interceptors.request.use(config => {
  // console.log('API 请求拦截器', config);
  // 例如添加 token
  // const token = localStorage.getItem('token');
  // if (token) {
  //   config.headers.Authorization = `Bearer ${token}`;
  // }
  return config;
}, error => Promise.reject(error));

// 响应拦截器（可选）
apiClient.interceptors.response.use(response => {
  // console.log('API 请求成功', response);
  return response.data; // 只返回响应中的数据部分
}, error => {
  // 统一错误处理
  console.error('API 请求错误', error);
  return Promise.reject(error);
});

// 定义具体请求函数

export function getUserList() {
  return apiClient.get('/users');
}

export function getUserById(id) {
  return apiClient.get(`/users/${id}`);
}

export function createUser(data) {
  return apiClient.post('/users', data);
}

export function updateUser(id, data) {
  return apiClient.put(`/users/${id}`, data);
}

export function deleteUser(id) {
  return apiClient.delete(`/users/${id}`);
}

export default apiClient;
